<template>
  <div class="ApartmentManagement">
    <el-form :inline="true" :model="searchForm" @keyup.enter.native="getDataList('search')">
      <el-form-item label="公寓名称">
        <el-input v-model="searchForm.apartmentName" placeholder="公寓名称"></el-input>
      </el-form-item>

      <!-- <el-form-item label="所有者">
        <el-input v-model="searchForm.owner"
                  placeholder="所有者"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button icon="el-icon-search" size="small" type="primary" @click="getDataList('search')">搜索
        </el-button>
        <el-button icon="el-icon-delete" size="small" plain type="primary" @click="reset()">清空
        </el-button>
      </el-form-item>

      <el-row>
        <el-col :span="12">
          <el-button icon="el-icon-plus" size="small" type="primary" @click="openModifyDialog()">添加公寓
          </el-button>
        </el-col>
      </el-row>

    </el-form>
    <el-table class="dataTable" v-loading="dataListLoading" :data="dataList"
              :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" border>
      <el-table-column label="公寓名称" prop="apartmentName">
      </el-table-column>
      <el-table-column label="公寓地址" prop="apartmentAddress">
      </el-table-column>
      <el-table-column label="创建人" prop="landlord">
      </el-table-column>
      <el-table-column label="操作" width="500">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openDetailDialog(scope.row)">查看</el-button>
          <el-button size="mini" type="primary" @click="openModifyDialog(scope.row)" v-if="scope.row.roleId==1">编辑
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          <el-button size="mini" type="primary" @click="openMpMsgDialog(scope.row)">发全员消息</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination :current-page="pageIndex" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :total="totalPage"
                   background layout="total, sizes, prev, pager, next, jumper" @size-change="sizeChangeHandle"
                   @current-change="currentChangeHandle">
    </el-pagination>

    <!-- 新增&修改公寓信息 -->
    <el-dialog :title="modifyForm.id ? '修改公寓信息' : '添加公寓'" :visible.sync="modifyDialog" width="40%"
               :before-close="cancelModifyDialog">
      <el-form class="modifyForm" ref="modifyForm" :model="modifyForm" :rules="modifyRule" label-width="40%">

        <el-form-item label="公寓名称" prop="apartmentName">
          <el-input style="width: 200px;" v-model="modifyForm.apartmentName" placeholder="请输入公寓名称"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>

        <el-form-item label="公寓地址" prop="apartmentAddress">
          <el-input style="width: 200px;" v-model="modifyForm.apartmentAddress" placeholder="请输入公寓地址"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>

        <el-form-item label="公寓描述" prop="apartmentDesc">
          <el-input style="width: 200px;" v-model="modifyForm.apartmentDesc" placeholder="请输入公寓描述"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between">
        <el-button @click="cancelModifyDialog()">取 消</el-button>
        <el-button type="primary" @click="modifyHandle()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 公寓信息详情 -->
    <el-dialog title="公寓信息详情" :visible.sync="detailDialog" width="40%" :before-close="cancelDetailDialog">
      <el-form class="detailForm" ref="detailForm" :model="detailForm" label-width="40%">
        <el-form-item label="公寓名称：" prop="apartmentName">
          <span>{{ detailForm.apartmentName }}</span>
        </el-form-item>
        <el-form-item label="公寓地址：" prop="apartmentAddress">
          <span>{{ detailForm.apartmentAddress }}</span>
        </el-form-item>
        <el-form-item label="公寓描述：" prop="apartmentDesc">
          <span>{{ detailForm.apartmentDesc }}</span>
        </el-form-item>
        <el-form-item label="所有者：" prop="landlord">
          <span>{{ detailForm.landlord }}</span>
        </el-form-item>
        <el-form-item label="创建时间：" prop="createTime">
          <span>{{ detailForm.createTime }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between">
        <el-button @click="cancelDetailDialog()">返 回</el-button>
      </span>
    </el-dialog>

    <!-- 发全员消息 -->
    <el-dialog title="公寓全员消息" :visible.sync="mpMsgDialog" width="40%"
               :before-close="cancelMpMsgDialog">
      <el-form class="mpMsgForm" ref="mpMsgForm" :model="mpMsgForm" :rules="mpMsgRule" label-width="40%">

        <el-form-item label="消息内容" prop="msgContent">
          <el-input style="width: 200px;" v-model="mpMsgForm.msgContent" placeholder="请输入内容名称"
                    @keyup.enter.native="mpMsgHandle()"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between">
        <el-button @click="cancelMpMsgDialog()">取 消</el-button>
        <el-button type="primary" @click="mpMsgHandle()">发 送</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import '../assets/css/ApartmentManagement.css'

import util from '../utils/tools'

export default {
  data() {
    return {
      userInfo: {},
      searchForm: {},
      dataListLoading: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 1,
      modifyDialog: false,
      modifyForm: {},
      modifyRule: {
        apartmentName: [{
          required: true,
          message: '公寓名称不能为空',
          trigger: 'blur'
        },],
        apartmentAddress: [{
          required: true,
          message: '公寓地址不能为空',
          trigger: 'blur'
        },],
        apartmentDesc: [{
          required: true,
          message: '公寓描述不能为空',
          trigger: 'blur'
        },],
      },
      detailDialog: false,
      detailForm: {},

      mpMsgDialog: false,
      mpMsgForm: {},
      mpMsgRule: {
        msgContent: [{
          required: true,
          message: '内容不能为空',
          trigger: 'blur'
        },],
      },
    }
  },

  computed: {},

  created() {
    let self = this

    if (sessionStorage.getItem('userInfo')) {
      self.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    }

    self.getDataList()
  },

  mounted() {
  },

  methods: {
    openMpMsgDialog(item) {
      this.mpMsgForm = util.deepCopy(item)
      this.mpMsgDialog = true
    },
    cancelMpMsgDialog() {
      this.mpMsgDialog = false
    },
    mpMsgHandle: function () {
      let self = this

      let msgContent = self.mpMsgForm.msgContent

      if(msgContent == undefined || msgContent.length == 0){
        alert("内容不能为空")
        return
      }

      let param = {
        msgType: 0,//ui消息的类型，目前不校验
        msgContent: msgContent,
        msgReceiverType: 1,//1公寓成员；2房间成员
        apartmentId: this.mpMsgForm.apartmentId
      }


      self.$axios
        ._sendUiMsg(param)
        .then((res) => {
          const datas = res.data
          if (datas.code == 0) {
            self.cancelMpMsgDialog()
            self.$message.success('发送成功')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error('系统异常，请稍后重试')
        })


    },

    // 清空查询条件
    reset() {
      let self = this
      Object.keys(self.searchForm).forEach((key) => (self.searchForm[key] = ''))
    },

    // 获取数据列表
    getDataList(type) {
      let self = this

      let param = {}

      if (type == 'search') {
        self.pageIndex = 1
        if (self.searchForm.apartmentName != '')
          param.apartmentName = self.searchForm.apartmentName
      }

      self.dataListLoading = true


      self.$axios
        ._getApartmentList(param)
        .then((res) => {
          const datas = res.data
          if (datas.code == 0) {
            let _dataList = datas.data.apartmentList
            if (_dataList) {
              self.dataList = _dataList
            } else {
              self.$message.error('还没有创建公寓')
              self.dataList = []
            }

            self.totalPage = self.dataList.length
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false

    },

    // 每页数
    sizeChangeHandle(val) {
      let self = this

      self.pageSize = val
      self.pageIndex = 1
      self.getDataList()
    },

    // 当前页
    currentChangeHandle(val) {
      let self = this

      self.pageIndex = val
      self.getDataList()
    },

    // 打开 新增&修改弹窗
    openModifyDialog: function (item) {
      let self = this
      // if (code) {
      //   self.$axios
      //     ._getApartmentInfo({
      //       apartmentCode: code,
      //     })
      //     .then((res) => {
      //       const datas = res.data
      //
      //       if (datas.code == 0) {
      //         self.modifyForm = datas.data
      //       } else {
      //         self.$message.closeAll()
      //         self.$message.error(datas.msg)
      //       }
      //     })
      //     .catch((error) => {
      //       self.$message.closeAll()
      //       self.$message.error('系统异常，请稍后重试')
      //     })
      // }


      // self.modifyForm = this.deepCopy(item)
      if(item){
        self.modifyForm = util.deepCopy(item)
      } else {
        self.modifyForm = {}
      }

      self.modifyDialog = true
    },

    // 新增&修改
    modifyHandle: function () {
      let self = this

      let apartmentName = self.modifyForm.apartmentName
      let apartmentAddress = self.modifyForm.apartmentAddress
      let apartmentDesc = self.modifyForm.apartmentDesc

      let param = {
        apartmentName: apartmentName,
        apartmentAddress: apartmentAddress,
        apartmentDesc: apartmentDesc
      }

      if (self.modifyForm.apartmentId) {

        param.apartmentId = self.modifyForm.apartmentId

        self.$axios
          ._putApartmentInfo(param)
          .then((res) => {
            const datas = res.data
            if (datas.code == 0) {
              self.cancelModifyDialog()
              self.getDataList('search')
              self.$message.success('修改成功')
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请稍后重试')
          })

      } else {

        self.$axios
          ._addApartmentInfo(param)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.cancelModifyDialog()
              self.getDataList('search')
              self.$message.success('添加成功')
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请稍后重试')
          })
      }
    },

    // 关闭 新增&修改弹窗
    cancelModifyDialog: function () {
      let self = this

      // Object.keys(self.modifyForm).forEach((key) => (self.modifyForm[key] = ''))
      // self.$refs.modifyForm.resetFields()
      self.modifyDialog = false
    },

    // 打开 公寓信息弹窗
    openDetailDialog: function (item) {
      let self = this

      // let str = {
      //   apartmentCode: code,
      // }

      self.detailForm = item

      // if (code) {
      //   self.$axios
      //     ._getApartmentInfo(str)
      //     .then((res) => {
      //       const datas = res.data
      //
      //       if (datas.code == 0) {
      //         self.detailForm = datas.data
      //       } else {
      //         self.$message.closeAll()
      //         self.$message.error(datas.msg)
      //       }
      //     })
      //     .catch((error) => {
      //       self.$message.closeAll()
      //       self.$message.error('系统异常，请稍后重试')
      //     })
      // }

      self.detailDialog = true
    },

    // 关闭 公寓信息弹窗
    cancelDetailDialog: function () {
      let self = this

      // Object.keys(self.detailForm).forEach((key) => (self.detailForm[key] = ''))

      self.detailDialog = false
    },

    // 删除公寓
    handleDelete(row) {
      let self = this

      self
        .$confirm(`是否确认要删除 "${row.apartmentName}" 公寓`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(function () {
          return self.delApartment(row.apartmentId)
        })
        .then((data) => {
        })
    },

    delApartment(apartmentId) {
      let self = this

      let param = {apartmentId:apartmentId}

      self.$axios
        ._deleteApartment(param)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.$message.success('删除成功')
            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/ApartmentManagement.vue